
<template>
  <div class="tf-vue-bg-grey-darker">
    <a href="javascript:void(0)" class="text-white text-decoration-none d-flex align-items-center justify-content-center w-100 h-100 p-2" data-bs-toggle="modal" data-bs-target="#carModal">
    <i class="icon-information"></i>
    </a>
    <div
      id="carModal"
      class="modal"
      tabindex="-1"
      aria-labelledby="discountModalLabel"
      aria-hidden="true" 
 
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content p-4">
          <div class="container">
            <div v-if="quoteType === 'BACKPACKER'">
              <div>
                <h4 class="text-center text-dark">Extended Cover for High Value Items</h4>
              </div>
              <p class="text-dark fw-bold">
                 For items with a value higher than the standard single item limit of £150, up to a maximum of £1,000 per item if lost, stolen or damaged overseas. Cover extends to smartphones, electronic tablets, laptops and cameras. See Section O of the <a class="text-dark fw-bolder text-decoration-none" :href="'/travel-insurance/' + policy">Policy Document</a> for full details.
              </p>
           
            </div>
          <div>
            <h4 class="text-center text-dark">Optional Policy Extras</h4>
          </div>
          <div>
            <p class="text-dark fw-bold">
              Top up cancellation cover (Section L): You may add an extra £13,000pp cover (in addition to the {{ cover.uk.cancellation }}pp included as standard). From £50pp for each £1,000pp of extra cover.
            </p>
            <p class="text-dark fw-bold">
              Car Hire Damage Excess Waiver (Section J): Covers a refund of the excess amount shown on your rental agreement up to £6,000pp. From £6pp per day (minimum 3 days).
            </p>
          </div>
      </div>

        <div class="text-center my-5">
        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
      </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { cover } from '../../amounts/cover';
export default {
  props: ['policy', 'quoteType', 'domain'],
  data() {
    return {
      cover,
      modalShow:false,
    }
  },
  computed: {
    title() {
      if(this.quoteType === 'SINGLEG') {
        return 'Single Trip Insurance'
      } else {
        return 'Annual Multi-Trip'
      }
    },
    currency() {
     const currency = this.domain === 'ie' ? '€' : '£'
      return currency
    }
  },
  methods: {
    hideModal() {
      this.modalShow = false
    },
  }
}
</script>
<style scoped>
  .container {
    width: 100%;
  }
</style>